
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { DiscountFormValues } from "@/types/discount";

interface DiscountValueInputProps {
  form: UseFormReturn<DiscountFormValues>;
}

export const DiscountValueInput = ({ form }: DiscountValueInputProps) => {
  return (
    <FormField
      control={form.control}
      name="discount_value"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            Discount Value 
            {form.watch("discount_type") === "percentage" ? " (%)" : " (IDR)"}
          </FormLabel>
          <FormControl>
            <Input
              type="number"
              {...field}
              onChange={(e) => field.onChange(parseFloat(e.target.value))}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

